import { render, staticRenderFns } from "./fav-pop.vue?vue&type=template&id=7b063e41&scoped=true"
import script from "./fav-pop.vue?vue&type=script&lang=js"
export * from "./fav-pop.vue?vue&type=script&lang=js"
import style0 from "./fav-pop.vue?vue&type=style&index=0&id=7b063e41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b063e41",
  null
  
)

export default component.exports